<template>
    <nav
        :class="{ active: navigating }"
        class="nibnut-sidenav"
        v-touch:swipe="swiped"
    >
        <ul class="nav">
            <router-link
                :to="{ name: 'home' }"
                v-slot="{ href, navigate }"
                custom
            >
                <li
                    :class="{ 'active': ($route.name === 'home') || ($route.name === 'ui-catalog') }"
                    class="nav-item"
                >
                    <base-link
                        :href="href"
                        @click.native="navigate($event); $emit('navigate', false)"
                    >
                        <app-icon glyph="home" :stroke-width="($route.name === 'home') || ($route.name === 'ui-catalog') ? 2 : 1" />
                        <span>{{ translate("Home") }}</span>
                    </base-link>
                </li>
            </router-link>
            <router-link
                v-if="is_at_least_administrator"
                :to="{ name: 'client.list' }"
                v-slot="{ href, navigate, isActive }"
                custom
            >
                <li
                    :class="{ 'active': isActive }"
                    class="nav-item"
                >
                    <base-link
                        :href="href"
                        @click.native="navigate($event); $emit('navigate', false)"
                    >
                        <app-icon glyph="contact" :stroke-width="isActive ? 2 : 1" />
                        <span>{{ translate("Clients") }}</span>
                    </base-link>
                </li>
            </router-link>
            <router-link
                v-if="is_at_least_administrator"
                :to="{ name: 'user.list' }"
                v-slot="{ href, navigate, isActive }"
                custom
            >
                <li
                    :class="{ 'active': isActive }"
                    class="nav-item"
                >
                    <base-link
                        :href="href"
                        @click.native="navigate($event); $emit('navigate', false)"
                    >
                        <app-icon glyph="users" :stroke-width="isActive ? 2 : 1" />
                        <span>{{ translate("Users") }}</span>
                    </base-link>
                </li>
            </router-link>
            <router-link
                v-else
                :to="{ name: 'profile' }"
                v-slot="{ href, navigate, isActive }"
                custom
            >
                <li
                    :class="{ 'active': isActive }"
                    class="nav-item"
                >
                    <base-link
                        :href="href"
                        @click.native="navigate($event); $emit('navigate', false)"
                    >
                        <app-icon glyph="user" :stroke-width="isActive ? 2 : 1" />
                        <span>{{ translate("Profile") }}</span>
                    </base-link>
                </li>
            </router-link>
            <router-link
                v-if="is_at_least_administrator"
                :to="{ name: 'settings' }"
                v-slot="{ href, navigate, isActive }"
                custom
            >
                <li
                    :class="{ 'active': isActive }"
                    class="nav-item"
                >
                    <base-link
                        :href="href"
                        @click.native="navigate($event); $emit('navigate', false)"
                    >
                        <app-icon glyph="settings" :stroke-width="isActive ? 2 : 1" />
                        <span>{{ translate("Settings") }}</span>
                    </base-link>
                </li>
            </router-link>
            <li
                v-if="installable"
                class="nav-item"
            >
                <base-link
                    href="#"
                    @click.prevent="$emit('install')"
                >
                    <app-icon glyph="arrow-down-circle" />
                    <span>{{ translate("Install") }}</span>
                </base-link>
            </li>
        </ul>
        <div class="nibnut-sidenav-footer">
            <div v-if="!navigating">
                &copy;&nbsp;{{ current_year }}<br />
                v.{{ app_version }}
            </div>
            <div v-else>
                &copy;&nbsp;{{ current_year }}&nbsp;{{ setting("customer_name") }}<br />
                {{  translate("App sprouted from a") }}&nbsp;<a href="https://nibnut.com"><base-image :src="nibnut_logo" alt="nibnut" /></a>&nbsp;&bull;&nbsp;v.{{ app_version }}
            </div>
        </div>
    </nav>
</template>

<script>
import { profile_utilities, misc_utilities, string_utilities } from "./nibnut/mixins"

import { BaseImage, BaseLink, AppIcon } from "./nibnut/components"

import nibnut_logo from "./assets/img/nibnut.png"

export default {
    mixins: [profile_utilities, misc_utilities, string_utilities],
    components: {
        BaseImage,
        BaseLink,
        AppIcon
    },
    methods: {
        swiped (direction) {
            if((direction === "left") || (direction === "right")) this.$emit("navigate", (direction === "right"))
        }
    },
    computed: {
        nibnut_logo () {
            return nibnut_logo
        }
    },
    props: {
        navigating: {
            type: Boolean,
            required: true
        },
        installable: {
            type: Boolean,
            required: false
        }
    }
}
</script>
